import { useEffect, useState } from 'react';

/**
 * @deprecated: This hook doesn't work great with SSR, please use CSS instead if
 * you can.
 */
export const useMatchMedia = (media: string): boolean | undefined => {
  const [matches, setMatches] = useState<boolean | undefined>();

  useEffect(() => {
    const mql = window.matchMedia(media);
    setMatches(mql.matches);

    const eventListener = (event: MediaQueryListEvent): void => {
      setMatches(event.matches);
    };

    mql.addEventListener('change', eventListener);

    return () => {
      mql.removeEventListener('change', eventListener);
    };
  }, [media]);

  return matches;
};
